<template>
  <div class="finance-wrap">
    <div class="box-top">
      <div class="top-item">
        <p>快付余额</p>
        <p class="balance">{{ $store.state.orgFastPayBalance }}元</p>
      </div>
      <div class="top-item">
        <p> <i class="iconfont icon-chongzhi" style="color: #1C9C1C;"></i>累计充值<b>{{ totalData.incomg }}</b>元
        </p>
        <p style="line-height: 36px;"> <i class="iconfont icon-chongzhi-1" style="color: #E41313;"></i>累计花费<b>{{
          totalData.outcome }}</b>元
        </p>
      </div>
      <div class="top-item" style="text-align: center;">
        <div><el-button type="primary" class="default" @click="showRecharge = true">充值快付</el-button></div>
        <div style="margin-top:10px"><el-button type="text"  @click="openApplyRecord">查看申请记录</el-button></div>
      </div>
    </div>
    <div class="box-input">
      <div class="box-input-left">
        <el-date-picker v-model="timeValue" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" @change="changeDate" value-format="yyyy-MM-dd">
        </el-date-picker>

        <el-select clearable v-model="financeForm.countryId" @change="searchFn" placeholder="签证地区" filterable>
          <el-option v-for="item in country" :key="item.id" :label="item.zhName" :value="item.id">
          </el-option>
        </el-select>

        <el-select clearable v-model="financeForm.visaTypeId" @change="searchFn" placeholder="签证类型">
          <el-option v-for="item in visaType" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>

        <el-select clearable v-model="financeForm.userId" @change="searchFn" placeholder="操作员">
          <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>

        <el-select clearable v-model="financeForm.type" @change="searchFn" placeholder="分类">
          <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>

      <div class="box-input-btn">
        <el-button class="box-input-btn-cz" @click="reset">重置</el-button>
        <el-button class="default" @click="getFinanceData(true)">导出Excel</el-button>
      </div>
    </div>


    <div class="box-table">
      <el-table :data="financeList"
        :header-cell-style="{ backgroundColor: '#F2F4F7', color: '#333', fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }"
        style="width: 100%" v-loading="loading" :height="$store.state.product.screen ? '820px' : '470px'"
        :cell-style="{ 'text-align': 'center' }" ref="refTable">
        <el-table-column prop="typeName" label="分类">
        </el-table-column>
        <el-table-column prop="createdTime" label="时间">
          <template slot-scope="scope">
            <div>
              <!-- {{ scope.row.createdTime ? scope.row.createdTime.slice(0, 10) : '' }} -->
              {{ scope.row.createdTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="操作员">
        </el-table-column>
        <el-table-column prop="countryName" label="国家/签证类型">
          <template slot-scope="scope">
            <div>
              {{ scope.row.countryName }}/{{ scope.row.visaTypeName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="applicantName" label="姓名/护照号">
          <template slot-scope="scope">
            <div>
              {{ scope.row.applicantName }}/{{ scope.row.applicantPassport }}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="amount" label="快付变动" width="70px">
          <template slot-scope="scope">
            <div>
              <span style="color: #1C9C1C;" v-if="scope.row.flag == 0">+{{ scope.row.amount }}</span>
              <span style="color: #E41313;" v-else>-{{ scope.row.amount }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="balance" label="快币余额" width="70px">
        </el-table-column>
        <el-table-column prop="marks" label="备注">
        </el-table-column>
      </el-table>
    </div>

    <div class="table-pagination">

      <el-pagination @current-change="currentChange" :current-page="pageIndex" :page-size="10"
        layout="total, prev, pager, next, jumper" :total="pageTotal">
      </el-pagination>
    </div>
    <ticketsRechargeKuai :visible='showRecharge' @close="showRecharge = false"></ticketsRechargeKuai>

    <!-- 申请记录对话框 -->
    <el-dialog :visible.sync="showApplyRecord" width="1200px" title="申请记录" :close-on-click-modal="false">
      <div class="box-input" style="margin-bottom: 15px;">
        <div class="box-input-left">
          <el-select clearable v-model="applyRecordForm.Status" placeholder="状态" style="width: 140px;">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="已通过" :value="1"></el-option>
            <el-option label="已拒绝" :value="-2"></el-option>
          </el-select>
          <el-input v-model="applyRecordForm.OrderNo" placeholder="订单号" style="width: 200px;"></el-input>
        </div>
        <div class="box-input-btn">
          <el-button class="box-input-btn-cz" @click="applyRecordReset">重置</el-button>
          <el-button class="default" @click="applyRecordSearch">查询</el-button>
        </div>
      </div>

      <div class="box-table">
        <el-table :data="applyRecordList"
          :header-cell-style="{ backgroundColor: '#F2F4F7', color: '#333', fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }"
          style="width: 100%" v-loading="applyRecordLoading"
          :cell-style="{ 'text-align': 'center' }">
          <el-table-column prop="orderNo" label="订单号" min-width="180">
          </el-table-column>
          <el-table-column prop="rechargeAmount" label="充值金额" min-width="100">
          </el-table-column>
          <el-table-column prop="amount" label="支付金额" min-width="100">
          </el-table-column>
          <el-table-column prop="userName" label="申请人账号" min-width="120">
          </el-table-column>
          <el-table-column prop="createdTime" label="申请日期" min-width="160">
          </el-table-column>
          <el-table-column prop="statusName" label="审批状态" min-width="100">
            <template slot-scope="scope">
              <span :class="['status-tag', scope.row.status === 1 ? 'approved' : 'failed']">
                {{ scope.row.statusName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="reviewTime" label="审核日期" min-width="160">
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="120">
          </el-table-column>
          <el-table-column prop="url" label="凭证" min-width="80">
            <template slot-scope="scope">
              <el-image v-if="scope.row.url" :src="scope.row.url" :preview-src-list="[scope.row.url]" fit="cover" style="width: 50px; height: 50px; cursor: pointer;"></el-image>
              <span v-else>无</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-pagination" style="text-align: right; margin-top: 15px;">
        <el-pagination @current-change="applyRecordPageChange" :current-page="applyRecordForm.pageIndex" :page-size="applyRecordForm.pageSize"
          layout="total, prev, pager, next, jumper" :total="applyRecordTotal">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { visatypelist, countrylist } from '@/api/personal.js'
import { getorgfastpay, orguserlist, orgfinancetypeselect, getorgfastpaytotaldata,queryrechargevisaorder } from '@/api/finance.js'
import ticketsRechargeKuai from '@/views/orderCenter/electron/components/rechargeKuai.vue';
import { export_json_to_excel } from '@/utils/Export2Excel';
import { EventBus } from '@/utils/eventBus.js';

export default {
  data() {
    return {
      visaType: [],
      country: [],
      financeList: [],
      countryData: [],
      financeForm: {
        visaTypeId: '',
        countryId: '',
        userId: '',
        type: '',
        startDate: '',
        endDate: ''
      },
      pageIndex: 1,
      pageTotal: 0,
      loading: false,
      showRecharge: false,
      showApplyRecord: false,
      applyRecordForm: {
        Status: '',
        OrderNo: '',
        pageIndex: 1,
        pageSize: 10
      },
      applyRecordList: [],
      applyRecordTotal: 0,
      applyRecordLoading: false,
      timeValue: '',
      totalData: {},
      userList: [],
      typeList: [],
    }
  },
  components: {
    ticketsRechargeKuai
  },
  created() {
    EventBus.$on('refreshOrgTotal', () => {
      this.getTotalData()
    });
  },
  mounted() {
    this.getFinanceData()
    this.getTotalData()
    this.getVisatypelist();
    this.getCountrylist();
    this.getOrgUserList()
    this.getOrgFinanceType()
  },
  methods: {
    //获取机构历史收支数据
    getTotalData() {
      getorgfastpaytotaldata().then(res => {
        if (res.code == 1) {
          this.totalData = res.data
        }
      })
    },
    searchFn() {
      this.pageIndex = 1
      this.getFinanceData()
    },
    getFinanceData(IsExport = false) {
      this.loading = true;
      this.financeForm['Page.Index'] = this.pageIndex
      this.financeForm['Page.Size'] = 10
      this.financeForm.IsExport = IsExport === true ? true : false
      getorgfastpay(this.financeForm).then(res => {
        this.loading = false;
        if (IsExport === true) {
          res.data.rows.forEach(item => {
            if (item.flag == 0) {
              item.amountStr = '+' + item.amount
            } else {
              item.amountStr = '-' + item.amount
            }
            item.countryExport = item.countryName + '/' + item.visaTypeName
            item.nameExport = item.applicantName + '/' + item.applicantPassport
          })
          const tHeader = ['分类', '时间', '操作员', '国家/签证类型', '姓名/护照号', '快币变动', '快币余额', '备注'] // 表格头部
          const filterVal = ["typeName", 'createdTime', 'userName', 'countryExport', 'nameExport', 'amountStr', 'balance', 'marks',] // 表格头部对应的数据字段名，用来过滤
          const filename = '快币消费记录'
          const data = this.formatJson(filterVal, res.data.rows)

          // 文件数据处理完成后，会自动下载
          export_json_to_excel({
            header: tHeader,
            data,
            filename
          })
        } else {
          this.financeList = res.data.rows
          this.pageTotal = res.data.total
        }
      })
    },
    formatJson(filterVal, tableData) {
      return tableData.map((v) => {
        return filterVal.map((j) => {
          return v[j]
        })
      })
    },
    getOrgUserList() {
      orguserlist().then(res => {
        if (res.code == 1) {
          this.userList = res.data
        }
      })
    },
    changeDate(val) {
      if (val) {
        this.financeForm.startDate = val[0]
        this.financeForm.endDate = val[1]
      } else {
        this.financeForm.startDate = ''
        this.financeForm.endDate = ''
      }
      this.searchFn()
    },
    getOrgFinanceType() {
      orgfinancetypeselect().then(res => {
        if (res.code == 1) {
          this.typeList = res.data
        }
      })
    },

    reset() {
      this.financeForm = {
        visaTypeId: '',
        countryId: '',
        userId: '',
        type: '',
        startDate: '',
        endDate: ''
      }
      this.searchFn();
    },

    // 签证大类
    getVisatypelist() {
      visatypelist({}).then(res => {
        this.visaType = res.data;
      })
    },
    getCountrylist() {
      countrylist({}).then(res => {
        this.country = res.data
      })
    },
    currentChange(val) {
      this.pageIndex = val;
      this.$refs.refTable.bodyWrapper.scrollTop = 0;
      this.getFinanceData();
    },
    openApplyRecord() {
      this.showApplyRecord = true;
      this.applyRecordForm.pageIndex = 1;
      this.getApplyRecordData();
    },
    getApplyRecordData() {
      this.applyRecordLoading = true;
      const params = {
        Status: this.applyRecordForm.Status,
        OrderNo: this.applyRecordForm.OrderNo,
        'Page.Index': this.applyRecordForm.pageIndex,
        'Page.Size': this.applyRecordForm.pageSize
      };
      queryrechargevisaorder(params).then(res => {
        this.applyRecordLoading = false;
        if (res.code == 1) {
          this.applyRecordList = res.data.rows || [];
          this.applyRecordTotal = res.data.total || 0;
        }
      });
    },
    applyRecordSearch() {
      this.applyRecordForm.pageIndex = 1;
      this.getApplyRecordData();
    },
    applyRecordReset() {
      this.applyRecordForm = {
        Status: '',
        OrderNo: '',
        pageIndex: 1,
        pageSize: 10
      };
      this.getApplyRecordData();
    },
    applyRecordPageChange(val) {
      this.applyRecordForm.pageIndex = val;
      this.getApplyRecordData();
    }
  }
}
</script>


<style lang="scss" scoped>
.finance-wrap {
  // width: 953px;
  width: calc(100% - 30px);

  ::v-deep .el-select {
    margin-right: 5px;
    width: 125px;
  }

  ::v-deep .el-input__inner {
    background: #F2F4F7;
    border: none;
  }

  ::v-deep .el-table__row {
    .cell {
      font-size: 12px;
    }
  }

  ::v-deep .el-date-editor {
    margin-right: 5px;
    width: 240px;

    .el-range-input {
      background: transparent;
    }

    .el-range__close-icon {
      width: 10px;
    }
  }

  .box-table {
    height: calc(100% - 210px) !important;
    ::v-deep .el-table__body-wrapper {
      height: 100% !important;
      height: auto!important;
    }
  }

  .box-top {
    width: 593px;
    background: #FFFFFF;
    box-shadow: 0px 3px 12px 1px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 10px;

    .top-item {
      width: 30%;

      p {
        color: #666;
        font-size: 12px;
      }

      .balance {
        color: #333333;
        font-size: 20px;
        font-weight: bold;
      }

      .iconfont {
        vertical-align: middle;
        margin-right: 5px;
      }
    }
  }

}

.box-input-left {
  display: flex;

}

.edit-wrap {

  .edit-item {
    // padding-left: 20px;


    span {
      cursor: pointer;
      display: inline-block;
      margin: 6px;

      &.lan {
        color: #3888E9;
      }

      &.copy {
        color: #9EA09E;
      }

      &.del {
        color: #E41313;
      }
    }
  }
}

.table-pagination {
  text-align: center;
  margin-top: 16px;
}

.status-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;

  &.approved {
    background-color: #67C23A;
    color: white;
  }

  &.failed {
    background-color: #F56C6C;
    color: white;
  }
}

.box-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  width: 100%;

  .box-input-btn {
    text-align: right;

    .box-input-btn-cz {
      background: #EAF3FF;
      color: #3888E9;
      border: none;
    }

    .box-input-btn-add {
      background: #D8F5E4;
      color: #54D8A5;
      border: none;
    }
  }
}
</style>